import { BaseError } from "@/domains/errors";
import { z } from "zod";

export const spaceAccountFeatureFlagsSchema = z.record(z.string(), z.boolean());

export type SpaceAccountFeatureFlags = z.infer<typeof spaceAccountFeatureFlagsSchema>;

export const parseSpaceAccountFeatureFlags = ({
  flags,
  errorMessage,
}: {
  flags: unknown;
  errorMessage: string;
}): SpaceAccountFeatureFlags => {
  const parseResult = spaceAccountFeatureFlagsSchema.safeParse(flags);
  if (!parseResult.success) {
    throw new BaseError({
      message: errorMessage,
      info: { zodError: parseResult.error.message },
    });
  }

  return parseResult.data;
};
